import React from 'react'
import RecordSection from './_RecordSection'
import InfoLine from './_InfoLine'
import { View } from '@react-pdf/renderer'

const Welfare = ({ epcr }) => {
  const welfare = epcr?.welfare ?? {}
  return (
    <RecordSection title="Welfare">
      <View
        style={{
          gap: 2,
          paddingHorizontal: 5,
          paddingVertical: 5,
        }}
      >
        <InfoLine label="Category" value={welfare.category} />
        <InfoLine label="What Happened" value={welfare.details} />
        <InfoLine
          label="Person Description"
          value={welfare.personDescription}
        />
        <InfoLine label="Actions Taken" value={welfare.actionsTaken} />
        <InfoLine label="Outcome" value={welfare.outcome} />
        <InfoLine label="Outcome Notes" value={welfare.outcomeNotes} />
      </View>
    </RecordSection>
  )
}

export default Welfare
